module.exports = __webpack_public_path__ + "static/speech-3fc8bdc4b13d881f7ca576cbed05db08.jpg";